import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
/** Window event WRT-12 dispatches for "Ask Assist to fix". */ export const ASK_ASSIST_EVENT = 'office-workspace-ask-assist';
const AssistContext = /*#__PURE__*/ createContext(null);
/** Outside an OfficeWorkspace there is no Assist tab: callers get null. */ export function useOfficeWorkspaceAssist() {
    return useContext(AssistContext);
}
export const OfficeWorkspaceAssistHostContext = /*#__PURE__*/ createContext(null);
function parseDetail(detail) {
    if (!detail || typeof detail !== 'object') return null;
    const d = detail;
    if (typeof d.prompt !== 'string' || typeof d.sectionAnchor !== 'string') return null;
    if (d.quote !== undefined && typeof d.quote !== 'string') return null;
    return {
        prompt: d.prompt,
        sectionAnchor: d.sectionAnchor,
        quote: d.quote
    };
}
export function OfficeWorkspaceAssistProvider({ children, onOpenAssistTab }) {
    const [prefill, setPrefill] = useState(null);
    const prefillRef = useRef(prefill);
    prefillRef.current = prefill;
    const openRef = useRef(onOpenAssistTab);
    openRef.current = onOpenAssistTab;
    const openAssistTab = useCallback(()=>openRef.current(), []);
    const consumePrefill = useCallback(()=>{
        const p = prefillRef.current;
        if (p) setPrefill(null);
        return p;
    }, []);
    useEffect(()=>{
        const onAsk = (e)=>{
            const next = parseDetail(e.detail);
            if (!next) return;
            setPrefill(next);
            openRef.current();
        };
        window.addEventListener(ASK_ASSIST_EVENT, onAsk);
        return ()=>window.removeEventListener(ASK_ASSIST_EVENT, onAsk);
    }, []);
    const value = useMemo(()=>({
            openAssistTab,
            prefill,
            consumePrefill
        }), [
        openAssistTab,
        prefill,
        consumePrefill
    ]);
    return /*#__PURE__*/ _jsx(AssistContext.Provider, {
        value: value,
        children: children
    });
}
